import { c as _c } from "react/compiler-runtime";
import { safeParseNumber } from '@morpho-org/blue-sdk-viem';
import { formatters, getDigitsFromPriceAndAmount } from '@morpho-org/ui-v6/utils';
import { useMemo } from 'react';
import { splitValueAndUnit } from '@/helpers/number';
import type { VaultV2ChartTotalDepositFormattedValues } from '../types';
import type { VaultHistoryMode } from './useCurrencyMode';
interface UseFormattedValuesParams {
  dataMode: VaultHistoryMode;
  totalAssets?: bigint | null;
  totalAssetsUsd?: number | null;
  asset?: {
    symbol?: string;
    decimals?: number;
    /** USD price scaled to 18 decimals. */
    price?: bigint;
  } | null;
}
export function useFormattedValues(t0) {
  const $ = _c(19);
  const {
    dataMode,
    totalAssets,
    totalAssetsUsd,
    asset
  } = t0;
  let t1;
  bb0: {
    if (totalAssetsUsd == null) {
      t1 = undefined;
      break bb0;
    }
    let t2;
    if ($[0] !== totalAssetsUsd) {
      t2 = safeParseNumber(totalAssetsUsd);
      $[0] = totalAssetsUsd;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    t1 = t2;
  }
  const totalAssetsUsdParsed = t1;
  let t2;
  if ($[2] !== asset?.decimals || $[3] !== dataMode || $[4] !== totalAssets || $[5] !== totalAssetsUsdParsed) {
    t2 = () => {
      let _valueFormat;
      if (dataMode === "totalAssetsUsd") {
        _valueFormat = formatters.short.default("-").digits(2).of(totalAssetsUsdParsed, 18);
      } else {
        _valueFormat = formatters.short.default("-").digits(2).of(totalAssets, asset?.decimals ?? 18);
      }
      const split = splitValueAndUnit(_valueFormat);
      return {
        value: split.value ?? "-",
        unit: split.unit ?? ""
      };
    };
    $[2] = asset?.decimals;
    $[3] = dataMode;
    $[4] = totalAssets;
    $[5] = totalAssetsUsdParsed;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  asset?.decimals;
  let t3;
  if ($[7] !== t2) {
    t3 = t2();
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const formattedValue = t3;
  asset?.symbol;
  asset?.price;
  asset?.decimals;
  let t4;
  bb1: {
    if (dataMode === "totalAssetsUsd") {
      let t5;
      if ($[9] !== totalAssetsUsdParsed) {
        t5 = formatters.commas.unit("$").digits(2).of(totalAssetsUsdParsed, 18);
        $[9] = totalAssetsUsdParsed;
        $[10] = t5;
      } else {
        t5 = $[10];
      }
      t4 = t5;
      break bb1;
    }
    let t5;
    if ($[11] !== asset?.decimals || $[12] !== asset?.price || $[13] !== asset?.symbol || $[14] !== totalAssets) {
      t5 = formatters.commas.unit(asset?.symbol).digits(getDigitsFromPriceAndAmount(asset?.price, totalAssets, asset?.decimals ?? 18)).of(totalAssets, asset?.decimals ?? 18);
      $[11] = asset?.decimals;
      $[12] = asset?.price;
      $[13] = asset?.symbol;
      $[14] = totalAssets;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = t5;
  }
  const detailedFormattedValue = t4;
  let t5;
  if ($[16] !== detailedFormattedValue || $[17] !== formattedValue) {
    t5 = {
      formattedValue,
      detailedFormattedValue
    };
    $[16] = detailedFormattedValue;
    $[17] = formattedValue;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}